import { useState } from "react";
import Nav from "./Nav";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCustomers, deleteCustomer } from "./api";

const Customer = () => {
  const [search, setSearch] = useState("");
  const queryClient = useQueryClient();

  // Fetch customers
  const {
    data: customers = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["customers"],
    queryFn: getCustomers,
  });

  // Delete mutation
  const mutation = useMutation({
    mutationFn: deleteCustomer,
    onSuccess: (deletedId) => {
      // Update cached data instantly (optimistic update)
      queryClient.setQueryData(["customers"], (oldData) =>
        oldData.filter((cust) => cust[0] !== deletedId)
      );
    },
  });

  // Search filter
  const filtered = customers.filter((k) => {
    const searchValue = search.toLowerCase();
    const area = k[2] || "";
    const mobile = k[3] || "";
    return (
      k[1]?.toLowerCase().includes(searchValue) ||
      area.toLowerCase().includes(searchValue) ||
      mobile.toLowerCase().includes(searchValue) ||
      (k[0] + "").toLowerCase().includes(searchValue)
    );
  });

  return (
    <>
      <Nav />
      <div className="container-fluid mt-5 pt-3">
        {/* Search Bar */}
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h3 className="fw-bold text-primary">Customer List</h3>
          <input
            type="search"
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            className="form-control"
            placeholder="🔍 Search customers..."
            style={{
              maxWidth: "300px",
              borderRadius: "20px",
              paddingLeft: "15px",
            }}
          />
        </div>

        {/* Loading & Error states */}
        {isLoading && (
          <div className="text-center text-muted">Loading customers...</div>
        )}
        {isError && (
          <div className="text-center text-danger">
            ❌ Failed to load customers
          </div>
        )}

        {/* Table inside Card */}
        {!isLoading && !isError && (
          <div className="card shadow border-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-primary">
                  <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Area</th>
                    <th>Mobile</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.length > 0 ? (
                    filtered.map((d) => (
                      <tr key={d[0]}>
                        <td>{d[0]}</td>
                        <td>{d[1]}</td>
                        <td>{d[2]}</td>
                        <td>{d[3]}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => mutation.mutate(d[0])}
                            disabled={mutation.isLoading}
                          >
                            {mutation.isLoading ? "Deleting..." : "🗑 Delete"}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-3">
                        No customers found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Customer;
